<template>
  <div>
    <p>
      Aquesta tarja serveix per a <strong>destacar dades en format de gràfiques</strong>.
    </p>
    <p>
      Aquest model de tarja accepta els següents formats:
    </p>
    <ul>
      <li><strong>1:1</strong>: model genèric per a compartir en la majoria de xarxes socials (Facebook, Instagram, Twitter, canals de Telegram i Whatsapp, etc.).</li>
    </ul>

    <div class="help-examples">
      <img src="./examples/11.png" alt="Exemple 1:1" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'chart-help'
}
</script>
